'use strict';

var _ = require('lodash');
var ClassUsageGridAggregationFactory = function ClassUsageGridAggregationFactory(DataAggregationFactory, momentService) {
  function ClassUsageGridAggregation() {
    DataAggregationFactory.call(this, 'fares-chart-mode', 'fares-class-usage-grid');
  }
  ClassUsageGridAggregation.prototype = Object.create(DataAggregationFactory.prototype);
  ClassUsageGridAggregation.constructor = ClassUsageGridAggregation;
  ClassUsageGridAggregation.prototype.aggregate = function (data) {
    var currentMonthIdx = getCurrentMonth(),
      months_to_fields = [];
    for (var m = 0; m < 12; m++) {
      var idx = (currentMonthIdx + m) % 12;
      months_to_fields[idx] = 'month' + _.padStart(m, 2, '0');
    }
    var results = {};
    for (var i = 0, length = data.length; i < length; i++) {
      var row = data[i];
      var fbcClassNameKey = row.fareBasisCode + '-' + row.className;
      if (!results[fbcClassNameKey]) {
        results[fbcClassNameKey] = {
          className: row.className,
          fareBasisCode: row.fareBasisCode
        };
        //all months should be filled with value even if they are blank, to show proper dataDrivenColumns
        for (var j = 0; j < 12; j++) {
          results[fbcClassNameKey]['month' + _.padStart(j, 2, '0')] = '';
        }
      }
      results[fbcClassNameKey][months_to_fields[row.month - 1]] = row.traffic;
    }
    return _.values(results);
  };
  function getCurrentMonth() {
    return momentService.now(momentService.FIELD.FARES_USAGE_DATE).month();
  }
  return ClassUsageGridAggregation;
};
ClassUsageGridAggregationFactory.$inject = ['DataAggregationFactory', 'MomentService'];
module.exports = ClassUsageGridAggregationFactory;